export * from './lookups';

export const ACTION_TYPE_PREFIX = '@@ortk';
